module.exports = __webpack_public_path__ + "static/media/uniMastery.2d988b6a.png";